import React from 'react';
import { Box, Container, Typography, Grid, Link } from '@mui/material';
import { Facebook, Twitter, Instagram, LinkedIn } from '@mui/icons-material';

const Footer = () => {
  return (
    <Box sx={{ backgroundColor: '#212121', color: '#fff', py: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Left Section - Quick Links */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Quick Links
            </Typography>
            <Box>
              <Link href="#" color="inherit" sx={{ display: 'block', mb: 1 }}>
                Home
              </Link>
              <Link href="#about" color="inherit" sx={{ display: 'block', mb: 1 }}>
                About Us
              </Link>
              <Link href="#services" color="inherit" sx={{ display: 'block', mb: 1 }}>
                Services
              </Link>
              <Link href="#contact" color="inherit" sx={{ display: 'block', mb: 1 }}>
                Contact
              </Link>
            </Box>
          </Grid>

          {/* Center Section - Social Media Links */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Follow Us
            </Typography>
            <Box>
              <Link href="https://facebook.com" color="inherit" sx={{ mr: 2 }}>
                <Facebook/>
              </Link>
              <Link href="https://twitter.com" color="inherit" sx={{ mr: 2 }}>
                <Twitter/>
              </Link>
              <Link href="https://instagram.com" color="inherit" sx={{ mr: 2 }}>
                <Instagram/>
              </Link>
              <Link href="https://linkedin.com" color="inherit" sx={{ mr: 2 }}>
                <LinkedIn/>
              </Link>
            </Box>
          </Grid>

          {/* Right Section - Contact Info */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Contact Info
            </Typography>
            <Box>
              <Typography variant="body2">Email: vantagefinserv@gmail.com </Typography>
              <Typography variant="body2">Address: Pune, Maharashtra - India</Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Footer Bottom */}
        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="body2">
            &copy; {new Date().getFullYear()} Vantage Finserv. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
